<template>
    <div>
      <Head>
        <title>{{organization.name}} at Backtoworkconnect.ie</title>
        <link rel="canonical" :href="'https://backtoworkconnect.ie/organization/'+organization.alias" />
        <meta head-key="description" name="description" :content="organization.description" />
      </Head>
      <v-container class="lighten-5" style="padding-bottom:65px">
        <BackButton></BackButton>
        <v-card outlined elevation="24">
           
            <v-card-title>
                <span class="text-lg-h3 text-md-h4">{{organization.name}}</span>
                
            </v-card-title>
            <v-card-subtitle class="mt-1">
                <v-btn outlined color="primary" v-if="organization.is_returner_friendly">Returner friendly</v-btn>
            </v-card-subtitle>
            <v-card-text style="min-height:500px">
                <v-container class="border-bottom-purple mb-5">
                    <v-row>
                        <v-col  cols="12" lg="9" sm="12">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="10" sm="12" class="bottom-border-purple">
                                        <span class="text-h5">Contact</span>
                                    </v-col>
                                    <v-col lg="6" md="12" v-if="organization.contact_name">
                                        <span class="text-lg-h6">Contact Name <v-icon>mdi-account</v-icon></span>
                                        <p>{{ organization.contact_name }}</p>
                                    </v-col>
                                    <v-col lg="6"   md="12" v-if="organization.url">
                                        <span class="text-lg-h6">Website <v-icon>mdi-web</v-icon></span>
                                        <p><a :href="organization.url" target="_blank">{{ organization.url }}</a></p>
                                    </v-col>
                                    <v-col lg="6"   md="12" v-if="organization.email">
                                        <span class="text-lg-h6">Email <v-icon>mdi-email</v-icon></span>
                                        <p>{{ organization.email }}</p>
                                    </v-col>
                                    <v-col lg="6"  md="12" v-if="organization.phone">
                                        <span class="text-lg-h6">Phone <v-icon>mdi-phone</v-icon></span>
                                        <p>{{ organization.phone }}</p>
                                    </v-col>
                                    
                                    <v-col lg="6"  md="12">
                                        <span class="text-lg-h6">Location <a :href="getUrl()" target="_blank"><v-icon>mdi-map</v-icon></a></span>
                                        <p><span v-if="organization.address">{{ organization.address }}</span>&nbsp;<span v-if="organization.city">{{ organization.city }}</span>&nbsp;<span v-if="organization.postal_code">{{ organization.postal_code }}</span>&nbsp;{{organization.region}}&nbsp;<a :href="getUrl()" target="_blank"><v-icon>mdi-open-in-new</v-icon></a></p>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="10" sm="12" class="bottom-border-purple">
                                        <span class="text-h5">Details</span>
                                    </v-col>
                                </v-row>
                                <v-row v-if="organization.description">
                                    <v-col cols="12"  md="12">
                                        <span class="text-lg-h6">Description</span>
                                        <div class="rich-text" v-html="organization.description"></div>
                                    </v-col>
                                </v-row>
                                
                            </v-container>
                        </v-col>
                        <v-col cols=12 lg="3" sm="12" class="hidden-md-and-down">
                            <v-card outlined elevation="24" shaped >
                                <v-card-title class="bottom-border-purple dark-grey--text text-h6 mb-4">Company Information</v-card-title>
                                <v-card-text class="text-center p-10">
                                    <v-img :src="baseurl + '/img/' + organization.photo_path" max-height="250" contain class="margin:auto"></v-img>
                                    <hr class="fat-hr"></hr>
                                    <span class="text-h5">{{ organization.name }}</span>
                                    <v-spacer class="mb-5"></v-spacer>
                                    <a :href="organization.facebook" v-if="organization.facebook"><v-icon>mdi-facebook</v-icon></a>
                                    <a :href="organization.twitter" v-if="organization.twitter"><v-icon>mdi-twitter</v-icon></a>
                                    <a :href="organization.instagram" v-if="organization.instagram"><v-icon>mdi-instagram</v-icon></a>
                                    <a :href="organization.linkedin" v-if="organization.linkedin"><v-icon>mdi-linkedin</v-icon></a>
                                    
                                    <template v-if="organization.spotlight_url">
                                        <v-spacer class="mb-5"></v-spacer>
                                        <a :href="organization.spotlight_url" target="_blank">
                                            <v-img v-if="organization.spotlight_image" :src="organization.spotlight_image" max-height="250" contain class="margin:auto"></v-img>
                                            <span v-if="organization.spotlight_image_title" class="text-subtitle-2">{{ organization.spotlight_image_title }}</span>
                                            <span v-else class="text-subtitle-2">Back to Work with {{ organization.name }}</span>
                                        </a>
                                    </template>
                                    <template v-if="organization.spotlight_video">
                                        <v-spacer class="mb-5"></v-spacer>
                                        <video 
                                            :src="organization.spotlight_video" 
                                            controls 
                                            preload="metadata"
                                            style="max-height: 250px; width: 100%;"
                                            class="margin:auto"
                                        >
                                            Your browser does not support the video tag.
                                        </video>
                                            <span v-if="organization.spotlight_video_title" class="text-subtitle-2">{{ organization.spotlight_video_title }}</span>
                                            <span v-else class="text-subtitle-2">Back to Work with {{ organization.name }}</span>
                                    </template>
                                    <v-spacer class="mb-5"></v-spacer>
                                    <v-btn v-if="jobs && jobs.data && jobs.data.length" @click="searchJobs">View All Jobs</v-btn>
                                    <v-spacer class="mb-5"></v-spacer>
                                    <v-btn v-if="courses && courses.data && courses.data.length" @click="searchCourses">View All Courses</v-btn>
                                </v-card-text>
                            </v-card>
                            <template v-if="0 && courses && courses.data && courses.data.length" class="mt-5 hidden-md-and-down">
                                <v-card outlined shaped elevation=24  class="mt-5">
                                    <v-card-title class="text-h6 dark-grey--text">Training Courses</v-card-title>
                                    <v-card-text>
                                        <CourseSquareCard :key="j.id" v-for="j in courses.data" :course="j" :auth="auth" :state="state" :baseurl="baseurl" :prevurl="prevurl" 
                                        @toggleComponentLogin="toggleComponentLogin($event)" :categories="categories">
                                    </CourseSquareCard>
                                    <v-spacer class="border-bottom-purple"></v-spacer>
                                    </v-card-text>  
                                </v-card>
                            </template>
                            <template v-if="0 && jobs && jobs.data && jobs.data.length">
                                <v-card outlined shaped elevation=24 class="mt-5 hidden-md-and-down">
                                    <v-card-title class="text-h6 dark-grey--text">Jobs</v-card-title>
                                    <v-card-text>
                                        <JobSquareCard :key="j.id" v-for="j in jobs.data" :job="j" :auth="auth" :state="state" :baseurl="baseurl" :prevurl="prevurl" 
                                        @toggleComponentLogin="toggleComponentLogin($event)" :categories="categories">
                                    </JobSquareCard>
                                    <v-spacer class="border-bottom-purple"></v-spacer>
                                    </v-card-text>
                                </v-card>
                            </template>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card outlined elevation="24" shaped class="hidden-lg-and-up border-bottom-purple mb-10">
                    <v-card-text class="text-center">
                        <v-img :src="baseurl + '/img/' + organization.photo_path"></v-img>
                        <hr class="fat-hr"></hr>
                        <a :href="organization.facebook" v-if="organization.facebook"><v-icon>mdi-facebook</v-icon></a>
                        <a :href="organization.twitter" v-if="organization.twitter"><v-icon>mdi-twitter</v-icon></a>
                        <a :href="organization.instagram" v-if="organization.instagram"><v-icon>mdi-instagram</v-icon></a>
                        <a :href="organization.linkedin" v-if="organization.linkedin"><v-icon>mdi-linkedin</v-icon></a>
                        <v-spacer></v-spacer>
                        <v-btn v-if="jobs && jobs.data && jobs.data.length" @click="searchJobs">View All Jobs</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn v-if="courses && courses.data && courses.data.length" @click="searchCourses">View All Courses</v-btn>
                    </v-card-text>
                </v-card>
                <v-card v-if="courses && courses.data && courses.data.length" class="m-5">
                    <span class="text-h5 mt-5">Training Courses by {{ organization.name }}</span>
                    <CourseCard :key="j.id" v-for="j in courses.data" :course="j" :auth="auth" :state="state" :baseurl="baseurl" :prevurl="prevurl" 
                        @toggleComponentLogin="toggleComponentLogin($event)">
                    </CourseCard>
                    <v-spacer></v-spacer>
                    <v-container justify="center" align="center" class="text-center">
                        <v-btn color="primary" x-large v-if="courses && courses.data && courses.total > 3" @click="searchCourses">View All Courses</v-btn>
                    </v-container>  
                </v-card>
                <v-card v-if="jobs && jobs.data && jobs.data.length" class="m-5">
                    <span class="text-h5 mt-5">Jobs at {{ organization.name }}</span>
                    <JobCard :key="j.id" v-for="j in jobs.data" :job="j" :auth="auth" :state="state" :baseurl="baseurl" :prevurl="prevurl" 
                        @toggleComponentLogin="toggleComponentLogin($event)" :categories="categories">
                    </JobCard>
                    <v-spacer></v-spacer>
                    <v-container justify="center" align="center" class="text-center">
                        <v-btn color="primary" x-large v-if="jobs && jobs.data && jobs.total > 3" @click="searchJobs">View All Jobs</v-btn>

                    </v-container>
                    
                </v-card>
                
            </v-card-text>
            
        </v-card>
      </v-container>
    </div>
</template>
<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import axios from 'axios'
  
  import CourseCard from '@/Shared/CourseCard'
  import CourseSquareCard from '@/Shared/CourseSquareCard'

  import JobCard from '@/Shared/JobCard'
  import JobSquareCard from '@/Shared/JobSquareCard'
  import BackButton from '@/Shared/BackButton'

  export default {
    props: {
      organization: Object,
      auth: Object,
      state: String,
      isFavorite: Boolean,
      isApplied: Boolean,
      baseurl: String,
      prevurl: String,
      courses: Object,
      jobs: Object,
      categories: Array,
    },
    components: {
      Head,
      CourseCard,
      CourseSquareCard,
      JobCard,
      JobSquareCard,
      BackButton
    },
    layout: Layout,
    data() {
        return {
        }
    },
    watch: {
    },
    created() {
    },
    methods: {
        toggleComponentLogin(e) {
            console.log('results triggering login',e)
            if (!this.auth.user)
                this.$parent.$emit('toggleComponentLogin',e);
        
        },
        canApply() {
            if (!this.auth.user || (this.auth.user.roles.includes('admin') || this.auth.user.roles.includes('user')))
                return true;
            else
                return false;
        },
        getUrl() {
            return 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(this.organization.address +','+this.organization.region)

        },
        searchJobs() {
            this.$inertia.get(this.baseurl+'/search/job', {organization:this.organization.alias}, {

            }) 
        }
        ,
        searchCourses() {
            this.$inertia.get(this.baseurl+'/search/course', {organization:this.organization.alias}, {

            }) 
        }
    },
  }
  </script>
  
  <style>
    .fixedFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }
    </style>